import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
// import "./EventSlot.css";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import swal from "sweetalert";
import flag from "../../../../../assets/images/flag.png";
import clock from "../../../../../assets/images/meetupEvent/clock-icon.png";
import vector from "../../../../../assets/images/meetupEvent/Vector.png";
import "./LearningSessionDetails.css";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import ReactPlayer from "react-player";
import ScreenRecordShow from "../../../../Reuseable/ScreenRecordShow";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../../../HelperComponent/ContdownTimerRender";

const LearningSessionDetails = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const history = useHistory();

  const [event, setEvent] = useState("");
  const [slot, setSlot] = useState([]);
  const [eventTime, setEventTime] = useState([]);
  const [meetingJoin, setMeetingJoin] = useState(false);

  const fetchData = (event_id) => {
    axios
      .get(`/api/admin/learning_session/details/${event_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setEvent(res.data.event);
          setEventTime(res.data.event.event_date);
        }
      });
  };

  useEffect(() => {
    const event_id = props.match.params.id;

    fetchData(event_id);

    axios
      .get(`/api/admin/learning_session/registered_user/${event_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setSlot(res.data.users);
        }
      });
  }, [props.match.params.slug, history]);

  const joinRoute = (room_id) => {
    setMeetingJoin(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(`api/sdk/get-token/admin`)
        .then((res) => {
          setMeetingJoin(false);
          const authName = localStorage.getItem("auth_name");

          history.push(
            `/video-meeting?token=${res.data.token}&meetingId=${room_id}&webcamEnabled=true&micEnabled=true&name=${authName}&whiteboardEnabled=true&canDrawOnWhiteboard=true&canToggleWhiteboard=true&canChangeLayout=true&canPin=true&askJoin=false&participantCanToggleOtherMic=true&participantCanToggleOtherWebcam=true&canRemoveOtherParticipant=true`
          );
          // window.location.href = ;
        });
    });
  };

  const setReject = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/rejectMeetup/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/learning-session/pending");
        }
      });
    });
  };


  const startTime =
    moment(event.event_date).format("LL") + " " + event.start_time;

  const event_end_time = new Date(
    moment(event.event_date).format("LL") + " " + event.end_time
  ).getTime();

  const event_start_time = new Date(startTime).getTime();


  const histoy = useHistory();



  const setComplete = () => {
    axios
      .get(`/api/admin/learning_session/setComplete/${event.id}`)
      .then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          fetchData(event.slug);
        }
      });
  };

  const setAssignment = () => {
    axios
      .get(`/api/admin/learning_session/setAssignment/${event.id}`)
      .then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          histoy.push("/superstar-admin/learning-session/evaluation");
        }
      });
  };




  return (
    <>
      <div className="">
        {Number(event.status) > 0 ? (
          <div className="row mb-3">
            <div className="col-md-6 m-0 mb-3">
              <div className="card card-bg p-3 me-2">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="img-fluid Banner-SME-b "
                />

                {/* {event.banner ? (
                  <>
                    <Link
                      to={`${props.urlLink}/${event.slug}`}
                      className="Link"
                    >
                      <img
                        src={serverUrl + event.banner}
                        className="img-fluid img-fluid Banner-SME-b"
                        alt=""
                        style={{ maxHeight: "400px", width: "100%" }}
                      />
                    </Link>
                  </>
                ) : (
                  <>
                    <ReactPlayer
                      url={serverUrl + event.video}
                      controls={true}
                      volume={1}
                      width="100%"
                      maxHeight="400px"
                      className="img-fluid Banner-SME-b"
                      style={{ margin: "0 auto" }}
                    />
                  </>
                )} */}
                  <Countdown
                      date={startTime}
                      renderer={ContdownTimerRender}
                    />
              </div>
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="registration-head  card-bg mb-1">
                  <h5 className="text-warning fw-bold p-2">Registration </h5>
                </div>

                <div className="row registration-body  card-bg m-0 pt-3">
                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light smallTxtP">
                          Registration Start:
                        </span>
                        <br></br>
                        <span className=" text-warning fw-bold smallTxtP">
                          {moment(event.registration_start_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light smallTxtP">
                          Registration End:
                        </span>
                        <br></br>
                        <span className=" text-warning fw-bold smallTxtP">
                          {moment(event.registration_end_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row mb-3">
            <div className="col-md-7 m-0 mb-3">
              <div className="card card-bg p-3 me-2">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="img-fluid Banner-SME-b"
                  style={{ height: "330px" }}
                />
              </div>
            </div>

            <div className="col-md-5">
              {/* <div className="card card-bg py-5">
                <div className="row">
                  <div className="col-md-6 d-flex justify-content-center align-items-center">
                    <img src={clock} className="img-fluid p-3" alt="" />
                  </div>
                  <div className="col-md-6 d-flex align-items-center">
                    <div className="mx-3">
                      <h2 className="text-warning">Event Details submitted</h2>
                      <p className="text-light">
                        Waiting for &nbsp;
                        {event.star_approve_status === 1 ? (
                          <span className="fw-bold">Manager Admin</span>
                        ) : (
                          <span className="fw-bold">SuperStar</span>
                        )}
                        &nbsp; Approval
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        )}

        <div className="row mt-1">
          <div className="col-md-12">
            <div className="card card-bg shadow">
              <div className="card-body">
                <h5 className="text-light pb-3">{event.title}</h5>

                <h5 className="text-warning">Instruction</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={event.instruction} />
                </p>

                <h5 className="text-warning">Description</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={event.description} />
                </p>

                <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                  <h5 className="text-warning pt-2 ">Event Date</h5>
                  <p className="text-light fw-bold pt-2">
                    {moment(event.event_date).format("LL")} |{" "}
                    {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}-
                    {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row my-3">

          <ScreenRecordShow roomId={event.room_id} />

          {/* register user */}
          <div className="col-md-12">
            <div className="card card-bg solt-card">
              <div className="card-body">
                <h3 className="text-warning">
                  <img src={vector} alt="clock" className="mx-2"></img>
                  Registered User ({slot.length})
                </h3>
                <div className="row my-3">
                  {slot.map((user, index) => (
                    <div className="col-md-3 col-lg-2 mb-2 ">
                      <p className="sold-small-card fw-bold text-ellipsis">
                        <img
                          src={imageCdnUrl + user.user?.image}
                          className="img-fluid mx-2 p-1"
                          alt=""
                          style={{ height: "50px", width: "50px" }}
                        />
                        {user.user?.first_name} {user.user?.last_name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="card card-bg mt-3">
            <div className="row">
              <div className="col-md-4 d-flex justify-content-center align-items-center">
                <img src={clock} className="img-fluid p-3" alt="" />
              </div>
              <div className="col-md-4 d-flex align-items-center">
                <div className="mx-3">
                  <h2 className="text-warning">Event Details submitted</h2>
                  <p className="text-light">
                    &nbsp;
                    {Number(event.status) < 1 ? (
                      <span className="fw-bold">
                        Waiting for Super Star & Manager Approval
                      </span>
                    ) : Number(event.status) < 2 ? (
                      <span className="fw-bold">
                        Waiting for Manager Admin Approval
                      </span>
                    ) : Number(event.status) == 11 ? (
                      <span className="text-warning">Rejected</span>
                    ) : (
                      <>
                        (
                        <span className="text-warning">
                          Approved By Superstar And Manager Admin
                        </span>
                        )
                      </>
                    )}
                    &nbsp;
                  </p>
                </div>
              </div>

              <div
                className="col-md-4"
                style={{ borderLeft: "1px dashed yellow" }}
              >
                <h5 className="text-light text-center my-3">Status</h5>
                <div className="d-flex justify-content-center align-items-center">
                  <div style={{ width: 150, height: 150 }}>
                    {Number(event.status) > 1 && Number(event.status) != 11 ? (
                      <CircularProgressbarWithChildren
                        value={100}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">100% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : Number(event.status) === 1 ? (
                      <CircularProgressbarWithChildren
                        value={50}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">50% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : (
                      <CircularProgressbarWithChildren
                        value={0}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">0% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {Number(event.status) === 2 &&
              event_start_time <= new Date().getTime() &&
              event_end_time > new Date().getTime() ? (
              <div className="mt-3">
                {meetingJoin ? null : (
                  <div className="col-md-3 mx-auto">
                    <button
                      className="btn btnJoinNow w-100 fw-bold px-5"
                      onClick={() => joinRoute(event.room_id)}
                    >
                      Join Now
                    </button>
                  </div>
                )}
              </div>
            ) : Number(event.status) === 2 &&
              event_end_time < new Date().getTime() &&
              Number(event.assignment) === 1 ? (
              <div className="mt-3 col-md-3 mx-auto">
                <button
                  className="btn btnConfirm w-100 fw-bold px-5"
                  onClick={setAssignment}
                >
                  Start Assignment Session
                </button>
              </div>
            ) : Number(event.status) < 1 ? (
              <div className="mt-3 col-md-3 mx-auto">
                <Link
                  to={`/superstar-admin/learning-session/edit/${event.id}`}
                >
                  <button className="btn btnEditTest w-100 fw-bold px-3 mx-3">
                    Edit
                  </button>
                </Link>
              </div>
            ) : Number(event.status) === 2 &&
              event_end_time < new Date().getTime() &&
              Number(event.assignment) === 1 ? (
              <div className="mt-3 col-md-3 mx-auto">
                <button
                  className="btn btnConfirm w-100 fw-bold px-5"
                  onClick={setComplete}
                >
                  Set Completed
                </button>
              </div>
            ) : Number(event.status) === 9 ? (
              <div className="mt-3 col-md-3 mx-auto">
                <button className="btn btnConfirm w-100 fw-bold px-5" disabled>
                  Completed
                </button>
              </div>
            ) : Number(event.status) === 3 ? (
              <div className="mt-3 col-md-3 mx-auto">
                <button className="btn btnEditTest w-100 fw-bold px-5" disabled>
                  Assignment Session Started
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LearningSessionDetails;
